export default __webpack_public_path__ + "static/media/Hiw1.b965c2be.jpg";